import { Geometry, View } from '@antv/g2';
import { each } from '@antv/util';
import { geometry as geometryAdaptor } from '../../adaptor/geometries/base';
import { AXIS_META_CONFIG_KEYS } from '../../constant';
import { pick, deepAssign } from '../../utils';
import { Axis, Interaction } from '../../types';
import { IView } from './types';

/**
 *
 * @param params åé¢å¾ åæ°
 * @returns facet eachView çåè°è®¾ç½®æ¯ä¸ª view çå±ç¤º
 */
export function execViewAdaptor(viewOfG2: View, options: IView): void {
  const { data, coordinate, interactions, annotations, animation, tooltip, axes, meta, geometries } = options;

  // 1. data, optional
  if (data) {
    viewOfG2.data(data);
  }

  // 2. meta éç½®
  let scales: Record<string, any> = {};
  if (axes) {
    each(axes, (axis: Axis, field: string) => {
      scales[field] = pick(axis, AXIS_META_CONFIG_KEYS);
    });
  }

  scales = deepAssign({}, meta, scales);
  viewOfG2.scale(scales);

  // 3. coordinate éç½® (é»è®¤ç±é¡¶å±å³å®)
  if (coordinate) {
    viewOfG2.coordinate(coordinate);
  }

  // 4. axis è½´éç½® (é»è®¤ç±é¡¶å±å³å®ï¼ä½å¯ä»¥éè¿ false å¼ºå¶å³é­)
  if (axes === false) {
    viewOfG2.axis(false);
  } else {
    each(axes, (axis: Axis, field: string) => {
      viewOfG2.axis(field, axis);
    });
  }

  each(geometries, (geometry) => {
    // Geometry
    const { ext } = geometryAdaptor({
      chart: viewOfG2,
      options: geometry,
    });

    // Geometry adjust
    const { adjust } = geometry;
    if (adjust) {
      ext.geometry.adjust(adjust);
    }
  });

  // 5. interactions
  each(interactions, (interaction: Interaction) => {
    if (interaction.enable === false) {
      viewOfG2.removeInteraction(interaction.type);
    } else {
      viewOfG2.interaction(interaction.type, interaction.cfg);
    }
  });
  // 6. annotations
  each(annotations, (annotation) => {
    viewOfG2.annotation()[annotation.type]({
      ...annotation,
    });
  });

  // 7. animation (ååå¨ç»)
  if (typeof animation === 'boolean') {
    viewOfG2.animate(false);
  } else {
    viewOfG2.animate(true);
    // ææç Geometry é½ä½¿ç¨åä¸å¨ç»ï¼åä¸ªå¾å½¢å¦æåºå«ï¼todo èªè¡è¦çï¼
    each(viewOfG2.geometries, (g: Geometry) => {
      g.animate(animation);
    });
  }

  if (tooltip) {
    // 8. tooltip
    viewOfG2.interaction('tooltip');
    viewOfG2.tooltip(tooltip);
  } else if (tooltip === false) {
    viewOfG2.removeInteraction('tooltip');
  }
}
